import Client from '@/client'

export default {
  list() {
    return Client.get(`agents/`);
  },
  retrieve(slug) {
    return Client.get(`agents/${slug}/`)
  },
}